export const SIGNIN_ACTION = 'SIGNIN_ACTION';
export const SINGIN_SUCCESS_ACTION = 'SINGIN_SUCCESS_ACTION';
export const SINGIN_FAILURE_ACTION = 'SINGIN_FAILURE_ACTION';
